import React, { useEffect, useState } from 'react';
import { ArrowBack, ArrowForward } from '@mui/icons-material';
import {
  Box,
  Table,
  TableRow,
  TableCell,
  Checkbox,
  TableBody,
  Avatar,
  Switch,
  Button,
  TableHead,
} from '@mui/material';
import { useParams } from 'react-router-dom';

import { GuestToSelect } from '..';
import { stringAvatar } from '../../../utils/avatarGenerator';
import { Guest } from '../../../services/requests';

import {
  Header,
  SelectedLabel,
  TableContainerStyles,
  Text,
  Typography,
} from './styles';

import { InfoCard } from '../../../components/InfoCard';

interface StepMembrosProps {
  handleNext: () => void;
  handleBack: () => void;
  users: GuestToSelect[] | undefined;
  members: Guest[] | undefined;
  handleUserToInvite: (
    event: React.MouseEvent<unknown>,
    name: string,
    usr: GuestToSelect,
    idx: number,
    type: 'select' | 'profile',
  ) => void;
  handleEditMeeting: (formData: any) => void;
  loadingRequest: boolean;
  setSelectedAll: (type: boolean | null) => void;
  selectedAll: boolean | null;
  handleSelectedAll: () => void;
}

export const StepMembros = ({
  handleNext,
  handleBack,
  handleUserToInvite,
  users,
  handleEditMeeting,
  loadingRequest,
  setSelectedAll,
  selectedAll,
  handleSelectedAll,
}: StepMembrosProps) => {
  const params = useParams();

  const [newMeetingId, setNewMeetingId] = useState('');
  const label = { inputProps: { 'aria-label': 'Switch demo' } };

  useEffect(() => {
    if (params?.id) {
      setNewMeetingId(params?.id as string);
    }
  }, [params]);

  const getLabelForAmount = () => {
    const usersSelecteds = users?.filter(u => u?.selected);

    if (usersSelecteds?.length === 1) {
      return `${usersSelecteds?.length} selecionado`;
    }
    return `${usersSelecteds?.length} selecionados`;
  };

  return (
    <Box
      height="100%"
      display="flex"
      justifyContent="space-between"
      width="100%"
    >
      {!newMeetingId && users && users?.length < 1 ? (
        <Box
          display="flex"
          height="100%"
          flexDirection="column"
          justifyContent="space-between"
          width="100%"
        >
          <Box width="100%">
            <Header mt="20px">
              <span>
                Você será adicionado automaticamente como Administrador da
                Reunião
              </span>
            </Header>
            <Box mt="130px">
              <InfoCard
                title="Somente você foi adicionado neste Board"
                type="info"
              />
            </Box>
          </Box>
          <Box
            sx={{
              width: '100%',
              display: 'flex',
              justifyContent: newMeetingId ? 'flex-end' : 'space-between',
              marginTop: '20px',
              flex: '0 0 0',
            }}
          >
            {newMeetingId ? (
              ''
            ) : (
              <Button
                onClick={handleBack}
                sx={{
                  color: '#323232',
                  fontSize: '15px',
                  fontWeight: '500',
                  display: 'flex',
                  alignItems: 'center',
                  gap: '15px',
                  backgroundColor: '#EEEEEE',
                  padding: '6px 22px 6px 16px',
                  height: '42px',
                }}
              >
                <ArrowBack /> Voltar
              </Button>
            )}
            {newMeetingId ? (
              <Button
                variant="contained"
                color="success"
                type="submit"
                disabled={loadingRequest}
                onClick={handleEditMeeting}
                sx={{
                  color: '#ffffff',
                  fontSize: '15px',
                  fontWeight: '500',
                  display: 'flex',
                  alignItems: 'center',
                  gap: '15px',
                }}
              >
                Salvar alterações
              </Button>
            ) : (
              <Button
                onClick={handleNext}
                variant="contained"
                color="success"
                sx={{
                  color: '#ffffff',
                  fontSize: '15px',
                  fontWeight: '500',
                  display: 'flex',
                  alignItems: 'center',
                  gap: '15px',
                  height: '42px',
                }}
              >
                Continuar
                <ArrowForward />
              </Button>
            )}
          </Box>
        </Box>
      ) : (
        <Box
          display="flex"
          height="100%"
          justifyContent="space-between"
          width="100%"
          flexDirection="column"
        >
          <Box width="100%" height="100%" display="flex" flexDirection="column">
            <Box
              display="flex"
              flexDirection="row"
              justifyContent="space-between"
              margin="10px 0px"
            >
              <Typography className="header-table">
                Selecione quem participará da reunião
              </Typography>
              <Typography className="header-table">Organizador</Typography>
            </Box>
            <Box
              width="100%"
              height="100%"
              display="flex"
              flexDirection="column"
            >
              <TableContainerStyles>
                <Table
                  sx={{
                    width: '100%',
                    display: 'flex',
                    flexDirection: 'column',
                    height: '100%',
                  }}
                  aria-labelledby="tableTitle"
                >
                  <TableHead>
                    <TableRow
                      hover
                      sx={{
                        cursor: 'pointer',
                      }}
                      selected={selectedAll || false}
                      onClick={handleSelectedAll}
                    >
                      <TableCell padding="checkbox" onClick={handleSelectedAll}>
                        <Checkbox
                          sx={{ padding: '0' }}
                          color="primary"
                          checked={selectedAll || false}
                          onClick={handleSelectedAll}
                        />
                      </TableCell>
                      <TableCell width="100%">
                        <SelectedLabel>Selecionar todos</SelectedLabel>
                      </TableCell>
                      <TableCell />
                    </TableRow>
                  </TableHead>
                  <TableBody
                    sx={{
                      width: '100%',
                      height: '100%',
                      display: 'flex',
                      flexDirection: 'column',
                      flex: '1 0 0',
                      overflowY: 'auto',
                    }}
                  >
                    {users?.map((row, index) => {
                      const labelId = `enhanced-table-checkbox-${index}`;

                      return (
                        <TableRow
                          hover
                          role="checkbox"
                          tabIndex={-1}
                          key={row.email}
                          selected={row.selected}
                          sx={{
                            cursor: 'pointer',
                            display: 'flex',
                            alignItems: 'center',
                            justifyContent: 'space-between',
                            minHeight: '65px',
                            borderTop: '1px solid rgba(224, 224, 224, 1)',
                            borderBottom: '1px solid rgba(224, 224, 224, 1)',
                          }}
                          onClick={event =>
                            handleUserToInvite(
                              event,
                              row.name,
                              row,
                              index,
                              'select',
                            )
                          }
                        >
                          <TableCell
                            padding="checkbox"
                            component="th"
                            sx={{ width: '100%', border: 'none' }}
                          >
                            <Box
                              display="flex"
                              flexDirection="row"
                              alignItems="center"
                              gap="20px"
                              width="100%"
                            >
                              <Checkbox
                                color="primary"
                                checked={row.selected}
                                sx={{ padding: '0' }}
                                inputProps={{
                                  'aria-labelledby': labelId,
                                }}
                                onClick={event =>
                                  handleUserToInvite(
                                    event,
                                    row.name,
                                    row,
                                    index,
                                    'select',
                                  )
                                }
                              />
                              <Box
                                display="flex"
                                flexDirection="row"
                                alignItems="center"
                                gap="20px"
                                width="100%"
                              >
                                {row?.avatar_url ? (
                                  <Avatar sx={{ width: '40px' }}>
                                    <img
                                      src={row?.avatar_url as string}
                                      alt="Foto de perfil"
                                      style={{ width: '100%' }}
                                    />
                                  </Avatar>
                                ) : (
                                  <Avatar
                                    {...stringAvatar(row.name!)}
                                    sx={{ width: '40px' }}
                                  />
                                )}
                                <Box
                                  display="flex"
                                  alignItems="start"
                                  flexDirection="column"
                                >
                                  <Text fontSize="15px" fontWeight="600">
                                    {`${row.name}`}
                                  </Text>
                                  {!params?.id && (
                                    <Text fontSize="14px" fontWeight="400">
                                      {`${
                                        (row.boardProfile as any) === 'BMS1'
                                          ? 'Admin'
                                          : 'Membro'
                                      }`}
                                    </Text>
                                  )}
                                </Box>
                              </Box>
                            </Box>
                          </TableCell>

                          <TableCell
                            component="th"
                            id={labelId}
                            scope="row"
                            sx={{ padding: '0', border: 'none' }}
                          >
                            {row.selected ? (
                              <Switch
                                {...label}
                                sx={{ paddingRight: '10px' }}
                                checked={row.profile === 'GS1'}
                                onClick={event =>
                                  handleUserToInvite(
                                    event,
                                    row.name,
                                    row,
                                    index,
                                    'profile',
                                  )
                                }
                              />
                            ) : (
                              <Switch
                                {...label}
                                sx={{ paddingRight: '10px' }}
                                disabled
                              />
                            )}
                          </TableCell>
                        </TableRow>
                      );
                    })}
                  </TableBody>
                </Table>
              </TableContainerStyles>
            </Box>
          </Box>

          <Box
            sx={{
              width: '100%',
              display: 'flex',
              justifyContent: newMeetingId ? 'flex-end' : 'space-between',
              marginTop: '20px',
              flex: '0 0 0',
            }}
          >
            {newMeetingId ? (
              ''
            ) : (
              <Button
                onClick={handleBack}
                sx={{
                  color: '#323232',
                  fontSize: '15px',
                  fontWeight: '500',
                  display: 'flex',
                  alignItems: 'center',
                  gap: '15px',
                  backgroundColor: '#EEEEEE',
                  padding: '6px 22px 6px 16px',
                  height: '42px',
                }}
              >
                <ArrowBack /> Voltar
              </Button>
            )}
            <Box display="flex" alignItems="center" gap="20px">
              <SelectedLabel>{getLabelForAmount()}</SelectedLabel>
              {newMeetingId ? (
                <Button
                  variant="contained"
                  color="success"
                  type="submit"
                  disabled={loadingRequest}
                  onClick={handleEditMeeting}
                  sx={{
                    color: '#ffffff',
                    fontSize: '15px',
                    fontWeight: '500',
                    display: 'flex',
                    alignItems: 'center',
                    gap: '15px',
                  }}
                >
                  Salvar alterações
                </Button>
              ) : (
                <Button
                  onClick={handleNext}
                  variant="contained"
                  color="success"
                  sx={{
                    color: '#ffffff',
                    fontSize: '15px',
                    fontWeight: '500',
                    display: 'flex',
                    alignItems: 'center',
                    gap: '15px',
                    height: '42px',
                  }}
                >
                  Continuar
                  <ArrowForward />
                </Button>
              )}
            </Box>
          </Box>
        </Box>
      )}
    </Box>
  );
};
